<div class="container" [style.--split.px]="viewModel.splitPx">
  <div class="left" style="margin-left: 1px;">
    <header class="toolbar" style="padding-right: 2rem;">
      <input pInputText [(ngModel)]="viewModel.url" placeholder="Enter URL…" />
      <p-button severity="info" (click)="go()">Go</p-button>
      <!-- <button (click)="back()">◀</button>
      <button (click)="forward()">▶</button> -->
      <!-- <button (click)="reload()">⟳</button> -->
      <!-- <button (click)="devtools()">DevTools</button> -->
      <!-- <button (click)="extract()">Extract Elements (JSON)</button> -->
    </header>

    <div class="scrollable-content">
      <app-live-test-executor></app-live-test-executor>

      <!-- Test Steps Identified Section -->
      <div class="test-steps-identified-section" style="display: none;">
        <p-accordion>
          <p-accordion-panel value="0">
            <p-accordion-header>
              <div class="accordion-header-content">
                <i class="pi pi-list-check"></i>
                <span>Generate Test steps from page</span>
                <span class="badge-count" *ngIf="viewModel.identifiedSteps().length > 0">({{ viewModel.identifiedSteps().length }})</span>
              </div>
            </p-accordion-header>
            <p-accordion-content>

            <div class="identified-steps-content">
              <div class="identified-steps-header">
                <p-button 
                  label="Generate Steps" 
                  icon="pi pi-sparkles" 
                  severity="info"
                  size="small"
                  (click)="generateTestSteps()"
                  [loading]="viewModel.isGenerating()">
                </p-button>
                <span class="hint-text">Analyze page and generate step suggestions</span>
              </div>

              <!-- Generated Steps List -->
              <div class="generated-steps-list" *ngIf="viewModel.identifiedSteps().length > 0">
                <div class="steps-group-header">
                  <i class="pi pi-info-circle"></i>
                  <span><strong>Click any step below to add it to your test scenario above.</strong> Select action steps and verification steps as needed.</span>
                </div>

                <!-- Next Steps Instructions -->
                <div class="next-steps-info" *ngIf="hasAddedSteps()">
                  <div class="info-icon">
                    <i class="pi pi-check-circle"></i>
                  </div>
                  <div class="info-content">
                    <strong>Steps added successfully!</strong>
                    <p>Next: Scroll up to see your steps in the Test Execution section. Replace <code>{{'{{'}}value{{'}}'}}</code> placeholders with actual values, then click "Run All Steps" or "Save".</p>
                  </div>
                </div>

                <!-- Action Steps (Input, Click, etc.) -->
                <div class="step-category" *ngIf="getActionSteps().length > 0">
                  <div class="category-label">
                    <i class="pi pi-bolt"></i>
                    <span>Actions</span>
                    <span class="count">({{ getActionSteps().length }})</span>
                  </div>
                  <div 
                    *ngFor="let step of getActionSteps(); let i = index" 
                    class="identified-step-item"
                    [class.added]="step.isAdded"
                    (click)="addStepToScenario(step)"
                    [title]="step.isAdded ? 'Already added to scenario' : 'Click to add to your test scenario'">
                    <span class="step-number">{{ i + 1 }}</span>
                    <div class="step-content">
                      <span class="step-text">{{ step.stepDescription }}</span>
                      <span class="step-type-badge" [class]="step.elementType">{{ step.elementType }}</span>
                    </div>
                    <i class="pi" [ngClass]="step.isAdded ? 'pi-check-circle added-icon' : 'pi-plus-circle add-icon'"></i>
                  </div>
                </div>

                <!-- Verification Steps -->
                <div class="step-category" *ngIf="getVerificationSteps().length > 0">
                  <div class="category-label verification">
                    <i class="pi pi-check-square"></i>
                    <span>Verifications</span>
                    <span class="count">({{ getVerificationSteps().length }})</span>
                  </div>
                  <div 
                    *ngFor="let step of getVerificationSteps(); let i = index" 
                    class="identified-step-item verification-item"
                    [class.added]="step.isAdded"
                    (click)="addStepToScenario(step)"
                    [title]="step.isAdded ? 'Already added to scenario' : 'Click to add to your test scenario'">
                    <span class="step-number">{{ i + 1 }}</span>
                    <div class="step-content">
                      <span class="step-text">{{ step.stepDescription }}</span>
                      <span class="step-type-badge" [class]="step.elementType">{{ step.elementType }}</span>
                    </div>
                    <i class="pi" [ngClass]="step.isAdded ? 'pi-check-circle added-icon' : 'pi-plus-circle add-icon'"></i>
                  </div>
                </div>
              </div>

              <div *ngIf="viewModel.identifiedSteps().length === 0 && !viewModel.isGenerating()" class="empty-state">
                <i class="pi pi-info-circle"></i>
                <p>Click "Generate Steps" to identify interactive elements on the current page</p>
                <p class="hint">Steps will include placeholders like <code>Enter {{'{{'}}value{{'}}'}}</code> for easy parameterization</p>
              </div>

              <div *ngIf="viewModel.isGenerating()" class="loading-state">
                <i class="pi pi-spin pi-spinner"></i>
                <p>Analyzing page elements...</p>
              </div>
            </div>
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>
      </div>

      <!-- AI Test Step Generator Section -->
      <div class="test-steps-identified-section" style="display: none;">
        <p-accordion>
          <p-accordion-panel value="0">
            <p-accordion-header>
              <div class="accordion-header-content">
                <i class="pi pi-sparkles"></i>
                <span>AI Test Step Generator</span>
                <span class="badge-count" *ngIf="viewModel.aiGeneratedSteps().length > 0">({{ viewModel.aiGeneratedSteps().length }})</span>
              </div>
            </p-accordion-header>
            <p-accordion-content>

            <div class="identified-steps-content">
              <!-- Scenario Input -->
              <div class="identified-steps-header">
                <span class="hint-text" style="flex: auto;">
                  <i class="pi pi-info-circle"></i>
                  Describe your test scenario in natural language and AI will generate executable steps
                </span>
              </div>

              <div style="margin-bottom: 1rem;">
                <textarea 
                  [(ngModel)]="viewModel.aiScenarioInput"
                  placeholder="Example: Login as admin user, search for student 'John Doe', verify student record appears, and update the email address"
                  rows="4"
                  style="width: 100%; padding: 0.75rem; border: 2px solid #dee2e6; border-radius: 6px; font-size: 0.9rem; resize: vertical;"
                  [disabled]="viewModel.isAIGenerating()">
                </textarea>

                <div style="display: flex; gap: 0.5rem; margin-top: 0.5rem; align-items: center;">
                  <p-button 
                    label="Generate with AI" 
                    icon="pi pi-sparkles" 
                    severity="success"
                    size="small"
                    (click)="generateWithAI()"
                    [loading]="viewModel.isAIGenerating()">
                  </p-button>

                  <p-button 
                    *ngIf="viewModel.aiGeneratedSteps().length > 0"
                    label="Add All Steps" 
                    icon="pi pi-plus-circle" 
                    severity="info"
                    size="small"
                    (click)="addAllAISteps()">
                  </p-button>

                  <p-button 
                    *ngIf="viewModel.aiGeneratedSteps().length > 0"
                    label="Clear" 
                    icon="pi pi-trash" 
                    severity="danger"
                    size="small"
                    [outlined]="true"
                    (click)="clearAISteps()">
                  </p-button>
                </div>
              </div>

              <!-- Error Message -->
              <div *ngIf="viewModel.aiError()" 
                   style="background: #fef3c7; border: 1px solid #fbbf24; color: #92400e; padding: 1rem; border-radius: 6px; margin-bottom: 1rem; white-space: pre-line;">
                <div style="display: flex; align-items: start; gap: 0.75rem;">
                  <i class="pi pi-exclamation-triangle" style="font-size: 1.25rem; margin-top: 0.125rem;"></i>
                  <div style="flex: 1;">
                    <strong style="display: block; margin-bottom: 0.5rem;">Could not generate steps</strong>
                    <div style="font-size: 0.9rem;">{{ viewModel.aiError() }}</div>
                  </div>
                </div>
              </div>

              <!-- Generated Steps List -->
              <div class="generated-steps-list" *ngIf="viewModel.aiGeneratedSteps().length > 0">
                <div class="steps-group-header">
                  <i class="pi pi-check-circle"></i>
                  <span><strong>AI generated {{ viewModel.aiGeneratedSteps().length }} test steps.</strong> Click individual steps to add them, or use "Add All Steps" above.</span>
                </div>

                <div 
                  *ngFor="let step of viewModel.aiGeneratedSteps(); let i = index" 
                  class="identified-step-item"
                  (click)="addAIStepToScenario(step, i)"
                  title="Click to add this step to your test scenario">
                  <span class="step-number">{{ i + 1 }}</span>
                  <div class="step-content">
                    <span class="step-text">{{ step }}</span>
                  </div>
                  <i class="pi pi-plus-circle add-icon"></i>
                </div>
              </div>

              <!-- Empty State -->
              <div *ngIf="viewModel.aiGeneratedSteps().length === 0 && !viewModel.isAIGenerating()" class="empty-state">
                <i class="pi pi-sparkles"></i>
                <p>Describe your test scenario and let AI generate the steps for you</p>
                <p class="hint">AI will analyze the current page elements and create contextually accurate test steps</p>
              </div>

              <!-- Loading State -->
              <div *ngIf="viewModel.isAIGenerating()" class="loading-state">
                <i class="pi pi-spin pi-spinner"></i>
                <p>AI is generating test steps...</p>
                <p style="font-size: 0.85rem; color: #6c757d;">This may take 5-10 seconds</p>
              </div>
            </div>
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>
      </div>
    </div>

    <!-- Dynamic Cards Section -->
    <!-- <div class="cards-container">
      <div *ngIf="pages.length === 0" class="empty-state">
        <p>Enter a URL and click Go to begin recording your test workflow</p>
      </div>
      <div class="cards-scroll" *ngFor="let page of pages; let i = index; trackBy: trackByPageId">
        <div class="page-card">
          <div class="card-header">
            <h3><input type="text" [(ngModel)]="page.name" class="name-input" placeholder="Enter page name..." /></h3>
            <p><strong>Seq:</strong> <span class="badge badge-sequence">{{ page.sequence }}</span></p>
            <p class="url-text">🔗 {{ page.url }}</p>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Footer within left panel -->
    <footer class="panel-footer">
      <p-button label="Cancel" icon="pi pi-times" severity="secondary" 
                (click)="cancel()" />
      <p-button label="Save" icon="pi pi-check" severity="info" 
                (click)="saveStepScenario()" />
    </footer>
  </div>

  <div class="gutter" (mousedown)="startDrag($event)"></div>
  <div class="right-ghost"></div>
</div>


